/**
 * @generated SignedSource<<4a810b44aa27637ba276580e114466bc>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarDetails_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getPdpEstimateSimilarSold_viewer">;
  readonly " $fragmentType": "PdpRespSidebarDetails_viewer";
};
export type PdpRespSidebarDetails_viewer$key = {
  readonly " $data"?: PdpRespSidebarDetails_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarDetails_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "RootArgument",
  "name": "isEstimateSimilarSoldVariant"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "afterDisplay"
    },
    (v0/*:: as any*/)
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarDetails_viewer",
  "selections": [
    {
      "condition": "isEstimateSimilarSoldVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "condition": "afterDisplay",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "kind": "InlineDataFragmentSpread",
              "name": "getPdpEstimateSimilarSold_viewer",
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "getHasEnoughSimilarSoldItems_viewer",
                  "selections": [
                    {
                      "condition": "isEstimateSimilarSoldVariant",
                      "kind": "Condition",
                      "passingValue": true,
                      "selections": [
                        {
                          "alias": "similarSoldItemsResults",
                          "args": [
                            {
                              "kind": "Literal",
                              "name": "first",
                              "value": 0
                            },
                            {
                              "kind": "Variable",
                              "name": "itemId",
                              "variableName": "itemId"
                            }
                          ],
                          "concreteType": "SimilarSoldItemsConnection",
                          "kind": "LinkedField",
                          "name": "similarSoldItems",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "totalResults",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ]
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": [
                    (v0/*:: as any*/),
                    {
                      "kind": "RootArgument",
                      "name": "itemId"
                    }
                  ]
                }
              ],
              "args": null,
              "argumentDefinitions": []
            }
          ]
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "326489828d5e8781cb48aa2817e91d19";

export default node;
